/**
 * isOralExamTask
 * --------------
 * Single source of truth for "is this task an oral exam?".
 *
 * Oral exams were promoted from `type: 'event'` with an oral_exam event kind
 * to a first-class `TaskType.oral_exam`. Both the type field and the legacy
 * `isOralExam` flag are checked so callers stay resilient during any
 * rollout transition.
 */
type MinimalTask = {
  type?: string;
  isOralExam?: boolean;
} | null | undefined;

export const isOralExamTask = (task: MinimalTask): boolean => {
  if (!task) return false;
  if (task.type === 'oral_exam') return true;
  return task.isOralExam === true;
};
